// angular.module('HeroPRO')
//   .directive('disableArrows',


export default function DisableArrowsDirective() {
    function disableArrows(event) {
        if (event.keyCode === 38 || event.keyCode === 40 || event.keyCode === 9 || event.keyCode === 13) {
            event.preventDefault();
        }
    }
    return {
        link(scope, element) {
            element.on('keydown', disableArrows);
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/smarty/disable-arrows.js